export default __webpack_public_path__ + "static/media/100_47747.fe87695b.jpg";